import React, { useEffect, useState } from 'react';
import {
  PlusCircle,
  Eye,
  BarChart,
  LineChart, // LineChart not currently used, but kept from original
  PieChart,
  Table,
  LayoutDashboard,
  Info,
  ThumbsUp,
  MessageSquare,
  Share2,
  Heart,
  MessageCircle,
  Bookmark,
  Link, // Link not currently used, but kept from original
  Users, // Users not currently used, but kept from original
  Globe,
  X,
  Calendar,

  Facebook,
  Instagram,
  Linkedin,
  Twitter,
  Send
} from "lucide-react";
import { Plus } from "lucide-react";
import img1 from "../assets/images/ganeshji.jpg";
import imageplaceholder from '../assets/images/imageplaceholder.jpg';
import { assetsUrl } from '../config/Config';

const PostCard1 = ({ data, onPostClick }) => {
  console.log('data >>', data);

  const handleIconClick = () => {
    onPostClick(data); // trigger callback and pass post data
  };

  const formatDate = (dateStr) => {
    const [day, month, year] = dateStr.split('-');
    const date = new Date(`${year}-${month}-${day}`);
    const options = { day: '2-digit', month: 'short', year: 'numeric' };
    return date.toLocaleDateString('en-GB', options).replace(',', '');
  }

  const truncateText = (text, limit = 30) => {
    if (!text) return "";
    return text.length > limit ? text.substring(0, limit) + "..." : text;
  }

  return (
    <div className="col-12 col-md-6 col-lg-3 mb-4">
      <div className="all-post-container">
        <div className="all-post-card">
          {/* Title */}

          {/* Image */}
          <div className="all-post-image">
          {/* <img src={imageplaceholder} alt="wallet" /> */}
          <img src={assetsUrl+'/mediagallery/static/' + data?.imagename} alt="wallet" />
          </div>
          <div className="all-post-content-box">
            <p className="all-post-title">{data?.posttitle}</p>

            <p className="all-post-description">{truncateText(data?.description, 60)}</p>

            {/* Header */}
            {data?.postedonplatform ?
              <div className="all-post-header">
                <div className="all-post-socials">
                  {
                    data?.postedonplatform?.map((item, index) => {
                      return (
                        <>
                       {
   
    item == "Facebook" ?
    <i 
        className="fa-brands fa-facebook" 
        style={{ fontSize: '18px', color: '#1877F2', marginRight: '10px' }} 
    ></i> :
 
    item == "Instagram" ?
    <i 
        className="fa-brands fa-instagram" 
        style={{ fontSize: '18px', color: '#E4405F', marginRight: '10px' }} 
    ></i> :
    

    item == "LinkedIn" ?
    <i 
        className="fa-brands fa-linkedin-in" 
        style={{ fontSize: '18px', color: '#0A66C2', marginRight: '10px' }} 
    ></i> :
    
    // Twitter Icon (X)
    item == "Twitter" ?
    <i 
        className="fa-brands fa-x-twitter" 
        style={{ fontSize: '18px', color: '#000000', marginRight: '10px' }} 
    ></i>
    : null
}
                        </>


                      );

                    })}
                </div>
              </div>

              : null}

            {/* Footer */}
            <div className="all-post-footer">
              <div className="all-post-col" onClick={() => { handleIconClick() }}>
                <Eye size={18} className="all-post-eye" />{" "}
                {/* <span className="all-post-view">8.7 </span>View */}
              </div>
              <div className="all-post-col">
                <p className="all-post-date">Created: {formatDate(data?.date)}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PostCard1